import React from 'react'

const Error = () => {
    return ( <
        img className = "mx-auto w-1/2 m-20"
        src = "cafe-time/img/404.jpg"
        alt = "404" / >

    )
}

export default Error